import type { TrackerCategory } from "@/types/tracker";

/** URL slug for each category's dedicated tracker route (e.g. /tracker/fish). Lives in its own
 * tiny module (not inside routes/Tracker.tsx) specifically so router.tsx can import it statically
 * without pulling Tracker's full lazy-loaded bundle into the main chunk. */
export const TRACKER_CATEGORY_SLUG: Record<TrackerCategory, string> = {
  Fish: "fish",
  Insects: "insects",
  Birds: "birds",
  Crops: "crops",
  Flowers: "flowers",
  Forageables: "forageables",
  Recipes: "recipes",
  "Wild Animals": "animals",
};

export const TRACKER_SLUG_TO_CATEGORY: Record<string, TrackerCategory> = Object.fromEntries(
  Object.entries(TRACKER_CATEGORY_SLUG).map(([category, slug]) => [slug, category as TrackerCategory]),
);
